import * as Linx from './Linx'

export const API_KEY_LINX = Linx.apiKey()

export const LIMITE_UNIDADES = 10

export const MOBILE_DEFAULT_SCREEN_WIDTH = 1024

export const TIMEOUT_REVALIDATE = 900
